import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const bordersWrapperFn = /* @__PURE__ */ createRecipe('borders-wrapper', {
  "color": "primary"
}, [])

const bordersWrapperVariantMap = {
  "color": [
    "primary",
    "neutral",
    "inverted"
  ]
}

const bordersWrapperVariantKeys = Object.keys(bordersWrapperVariantMap)

export const bordersWrapper = /* @__PURE__ */ Object.assign(memo(bordersWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'bordersWrapper',
  __getCompoundVariantCss__: bordersWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: bordersWrapperVariantKeys,
  variantMap: bordersWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, bordersWrapperVariantKeys)
  },
  getVariantProps: bordersWrapperFn.getVariantProps,
})